const onConversationStatusChangedHandler = ({ status }) => {
    window.WC._localStorage.set('conversationStatus', status);
};

export { onConversationStatusChangedHandler };
